import { Icon } from "@/components/Icon/Icon";
import type { FamilyKey } from "@/utils/types/flavor";
import type { IconName } from "@/utils/types/ui";

type TitleTagProps = {
  icon?: IconName;
  label: string;
  family?: FamilyKey;
  more?: number;
  onClick?: () => void;
};

export function TitleTag({
  icon,
  label,
  family,
  more = 0,
  onClick,
}: TitleTagProps) {
  return (
    <button type="button" className="wb-title-tag" title={label} onClick={onClick}>
      {family && (
        <span
          className="tag-fam-dot"
          style={{ background: `var(--fam-${family})` }}
        />
      )}
      {icon && <Icon name={icon} size={11} />}
      <span className="tag-label">{label}</span>
      {more > 0 && <span className="tag-more">+{more}</span>}
    </button>
  );
}
